import React from 'react'
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo'

export const PlayVideoIcon = props => {
  return <OndemandVideoIcon {...props} />
}
